// Export the action types used by redux
export const TOGGLE_POWER_ONOFF = 'TOGGLE_POWER_ONOFF';
export const CHANGE_SOUNDBANK = 'CHANGE_SOUNDBANK';
export const CHANGE_VOLUME = 'CHANGE_VOLUME';
export const PLAY_SOUND = 'PLAY_SOUND';



// WEBPACK FOOTER //
// ./src/redux/actionTypes.js